import type { UserProfile } from '../contexts/UserContext';

const parseHouseId = (value?: string | null) => {
  if (!value) return undefined;
  const trimmed = value.trim().toLowerCase();
  if (trimmed.startsWith('house')) {
    const match = trimmed.match(/house\s*(\d+)/i);
    if (match?.[1]) {
      return `house${match[1]}`;
    }
    return trimmed;
  }
  return undefined;
};

export const getHouseIdFromProfile = (profile?: UserProfile | null) => {
  if (!profile) return undefined;
  // House kiosk needs a stable org/house identifier across roles.
  // For mascots, the API typically provides the house org id via orgId/orgs.
  return (
    profile.houseId ??
    profile.orgId ??
    profile.orgs ??
    parseHouseId(profile.className) ??
    undefined
  );
};
